export default __webpack_public_path__ + "static/media/itheum.49a36e15.png";